import http from "./http.js";

let apiUrl = "https://www.dentaljack.de";

if (
  window.location.hostname == "localhost" ||
  window.location.hostname == "loc.dentaljack.de"
) {
  apiUrl = "https://loc.dentaljack.de";
}

if (window.location.hostname == "www.dentaljack.de") {
  apiUrl = "https://www.dentaljack.de";
}

export default {
  postChat(payload) {
    return http.post(apiUrl + `/postchat`, { payload });
  },
  postGuest(payload) {
    return http.post(apiUrl + `/postguest`, { payload });
  },
  postEmail(payload) {
    return http.post(apiUrl + `/postemail`, { payload });
  },
  postBerechnung(payload) {
    return http.post(apiUrl + `/postberechnung`, { payload });
  },
  postVergleich(payload) {
    return http.post(apiUrl + `/postvergleich`, { payload });
  },
  postTarif(payload) {
    //return http.post(`https://api.pro.de/tarif`, { payload });
    return http.post(apiUrl + `/posttarif`, { payload });
  },
  postMixed(payload) {
    return http.post(apiUrl + `/postmixed`, { payload });
  },
};
